
import { Component, Prop, Vue } from 'vue-property-decorator'

import PicPayModel from '../models/PicPay'

import EButton from './Button.vue'
import EPaymentInfo from './PaymentInfo.vue'

@Component({
  components: {
    EButton,
    EPaymentInfo,
  },
})
export default class PicPay extends Vue {
  @Prop({ required: true }) readonly picpay!: PicPayModel
}
